export const SIGN_IN_WITH_CODE_FORM_TEXT = {
  'sign_in_with_code_form.code_label': {
    'en-GB': 'Code',
    'nl-NL': 'Code',
  },
  'sign_in_with_code_form.submit_button_text': {
    'en-GB': 'Sign In',
    'nl-NL': 'Inloggen',
  },
  'sign_in_with_code_form.code_placeholder': {
    'en-GB': 'Enter code',
    'nl-NL': 'Code invoeren',
  },
  'sign_in_with_code_form.resend_code': {
    'en-GB': "Didn't receive a code?",
    'nl-NL': 'Niks ontvangen?',
  },
  'sign_in_with_code_form.resend_code_countdown': {
    'en-GB': "Didn't receive a code? Resend in",
    'nl-NL': 'Niks ontvangen? Verstuur opnieuw in',
  },
  'sign_in_with_code_form.resend_code_link': {
    'en-GB': 'Resend code',
    'nl-NL': 'Code opnieuw versturen',
  },
  'sign_in_with_code_form.error_heading': {
    'en-GB': 'Something went wrong',
    'nl-NL': 'Er is iets misgegaan',
  },
  'sign_in_with_code_form.error_message': {
    'en-GB': 'Please try again or request a new code below.',
    'nl-NL': 'Probeer het opnieuw of vraag hieronder een nieuwe code aan.',
  },
}
